import React, { useState, useEffect } from "react";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Portfolio from "./pages/PortfolioPage";
import Contact from "./components/Contact";
import Quotation from "./components/Quotation";
import Footer from "./components/Footer";

import SoftwareWebDevelopment from "./pages/SoftwareWebDevelopment";
import Cybersecurity from "./pages/Cybersecurity";
import TechRepair from "./pages/TechRepair";
import AdminDashboard from "./pages/AdminDashboard";

import "./styles/App.css";

function App() {
  const [showQuotation, setShowQuotation] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const pathname = window.location.pathname;

  // Handle service click
  const handleServiceClick = (serviceName) => {
    setSelectedService(serviceName);
    setShowQuotation(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Close quotation modal
  const closeQuotation = () => {
    setShowQuotation(false);
    setSelectedService("");
  };

  // Check for quote parameter in URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const quoteService = params.get("quote");
    if (quoteService) {
      setSelectedService(decodeURIComponent(quoteService));
      setShowQuotation(true);
    }
  }, []);

  // Admin Dashboard Route
  if (pathname.includes("admin-dashboard")) {
    return (
      <>
        <Navbar />
        <AdminDashboard />
        <Footer />
      </>
    );
  }

  // Portfolio Route
  if (pathname.includes("portfolio")) {
    return (
      <>
        <Navbar />
        <Portfolio />
        <Footer />
      </>
    );
  }

  // Software & Web Development Route
  if (pathname.includes("software-web-development")) {
    return (
      <>
        <Navbar />
        <SoftwareWebDevelopment onServiceClick={handleServiceClick} />
        {showQuotation && (
          <Quotation service={selectedService} onClose={closeQuotation} />
        )}
        <Footer />
      </>
    );
  }

  // Cybersecurity Route
  if (pathname.includes("cybersecurity")) {
    return (
      <>
        <Navbar />
        <Cybersecurity onServiceClick={handleServiceClick} />
        {showQuotation && (
          <Quotation service={selectedService} onClose={closeQuotation} />
        )}
        <Footer />
      </>
    );
  }

  // Tech Repair Route
  if (pathname.includes("tech-repair")) {
    return (
      <>
        <Navbar />
        <TechRepair onServiceClick={handleServiceClick} />
        {showQuotation && (
          <Quotation service={selectedService} onClose={closeQuotation} />
        )}
        <Footer />
      </>
    );
  }

  // Home Page (Default Route)
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services onServiceClick={handleServiceClick} />
      <Portfolio />

      {/* Global Quotation Modal */}
      {showQuotation && (
        <Quotation service={selectedService} onClose={closeQuotation} />
      )}

      <Contact />
      <Footer />
    </div>
  );
}

export default App;
